
const base32 = "ygc6daDdaDtbXYkhhnHi1XFys"
const Bi72 = "wqwdH9Rlows19wkBSx3w6osp"
const Ji = "wqwdH9Rlows19wkBSx3w6osp"
const Jk = "ygc6daDdaDtbXYkhhnHi1XFys"
const kirim = base32.substring(3, 19)
const birim = Bi72.substring(6, 22)
const JKE = Jk.substring(7, 23)
const JIV = Ji.substring(4, 20)
const baseInfo = {
  ku: kirim,
  iu: birim,
  JIEK: JKE,
  JIEi: JIV,
}
export default baseInfo



// WEBPACK FOOTER //
// ./src/request/base.js